import React, { useState, useEffect } from 'react';
import Filter from '../components/Filter';
import './../css/findprice.scss';
import { useDispatch } from 'react-redux';

import { getMerk, getSeri, getTipe, getSilinder, getTahun, getKota, getTransmisi } from '../utils/Filter';
import { filterPriceOverview, resetFilterOverview } from '../services/amplitude';

export const FilterFindPrice = ({ selected, getData }) => {
  const [filters, setFilters] = useState({
    brand: [{ value: null, label: 'Pilih Merek' }],
    seri: [{ value: null, label: 'Pilih Seri' }],
    tipe: [{ value: null, label: 'Pilih Tipe' }],
    silinder: [{ value: null, label: 'Pilih Silinder' }],
    startYear: [{ value: null, label: 'Pilih Tahun' }],
    endYear: [{ value: null, label: 'Pilih Tahun' }],
    period: [
      { value: null, label: 'Pilih Periode' },
      { value: '6', label: '6 Bulan' },
      { value: '5', label: '5 Bulan' },
      { value: '4', label: '4 Bulan' },
      { value: '3', label: '3 Bulan' },
      { value: '2', label: '2 Bulan' },
      { value: '1', label: '1 Bulan' },
    ],
    city: [{ value: null, label: 'Pilih Kota' }],
    transmisi: [
      { value: null, label: 'Pilih Transmisi' },
      { value: 'AT', label: 'AT' },
      { value: 'MT', label: 'MT' },
    ],
  });

  const [selectedValue, setSelected] = useState({
    brand: selected.brand,
    seri: selected.series,
    series: selected.series,
    tipe: selected.type,
    type: selected.type,
    silinder: selected.cylinder,
    cylinder: selected.cylinder,
    startYear: selected.startYear,
    endYear: selected.endYear,
    period: selected.period,
    city: selected.city,
    transmisi: selected.transmisi,
    year: selected.year,
  });

  const temp_res = {
    brand: [{ value: null, label: 'Pilih Merek' }],
    seri: [{ value: null, label: 'Pilih Seri' }],
    tipe: [{ value: null, label: 'Pilih Tipe' }],
    silinder: [{ value: null, label: 'Pilih Silinder' }],
    startYear: [{ value: null, label: 'Pilih Tahun' }],
    endYear: [{ value: null, label: 'Pilih Tahun' }],
    period: [
      { value: null, label: 'Pilih Periode' },
      { value: '6', label: '6 Bulan' },
      { value: '5', label: '5 Bulan' },
      { value: '4', label: '4 Bulan' },
      { value: '3', label: '3 Bulan' },
      { value: '2', label: '2 Bulan' },
      { value: '1', label: '1 Bulan' },
    ],
    city: [{ value: 'JAKARTA', label: 'JAKARTA' }],
    transmisi: [
      { value: null, label: 'Pilih Transmisi' },
      { value: 'AT', label: 'AT' },
      { value: 'MT', label: 'MT' },
    ],
    year: [],
  };

  const dispatch = useDispatch();

  const onCariHarga = () => {
    filterPriceOverview({
      item_brand: selectedValue.brand,
      item_series: selectedValue.seri,
      item_type: selectedValue.tipe,
      item_cylinder: selectedValue.silinder,
      item_year_start: selectedValue.startYear,
      item_year_end: selectedValue.endYear,
      item_transmission: selectedValue.transmisi,
      auction_period: `${selectedValue.period} Bulan`,
      item_city: selectedValue.city,
    });
    dispatch({
      type: 'SET_SELECTED_CARI_HARGA',
      value: {
        city: selectedValue.city,
        transmisi: selectedValue.transmisi,
        startYear: selectedValue.startYear,
        endYear: selectedValue.endYear,
        period: selectedValue.period,
        brand: selectedValue.brand,
        series: selectedValue.seri,
        cylinder: selectedValue.silinder,
        silinder: selectedValue.silinder,
        tipe: selectedValue.tipe,
        type: selectedValue.tipe,
        year: selectedValue.startYear,
      },
    });

    getData(selectedValue);
  };

  useEffect(() => {
    resetFilterOverview();

    Promise.all([
      getMerk().then((res) => {
        temp_res.brand = res;
      }),

      getSeri(selectedValue.brand).then((res) => {
        temp_res.seri = res;
      }),
      getTipe(selectedValue.brand, selectedValue.seri).then((res) => {
        temp_res.tipe = res;
      }),

      getSilinder(
        selectedValue.brand,
        selectedValue.seri,
        selectedValue.tipe,
      ).then((res) => {
        temp_res.silinder = res;
      }),

      getTahun(
        selectedValue.brand,
        selectedValue.seri,
        selectedValue.tipe,
        selectedValue.silinder,
      ).then((res) => {
        temp_res.startYear = res;
        temp_res.endYear = res;
        temp_res.year = res;
      }),

      getKota(
        selectedValue.brand,
        selectedValue.seri,
        selectedValue.tipe,
        selectedValue.silinder,
        selectedValue.startYear,
        selectedValue.endYear,
      ).then((res) => {
        temp_res.city = res;
      }),

      getTransmisi(
        selectedValue.brand,
        selectedValue.seri,
        selectedValue.tipe,
        selectedValue.cylinder,
        selectedValue.startYear,
        selectedValue.endYear,
        selectedValue.city,
      ).then((res) => {
        temp_res.transmisi = res;
      }),
    ]).then(() => {
      setFilters(temp_res);
    });
  }, []);

  const onChange = (event) => {
    switch (event.target.name) {
      case 'brand':
        if (event.target.value) {
          getSeri(event.target.value).then((res) => {
            setSelected({
              ...selectedValue,
              ...{
                // brand: null,
                seri: null,
                tipe: null,
                silinder: null,
                startYear: null,
                endYear: null,
                period: null,
                city: null,
                transmisi: null,
              },
              brand: event.target.value,
            });
            setFilters({ ...filters, seri: res });
          });
        } else {
          setSelected({
            ...selectedValue,
            brand: null,
            seri: null,
            tipe: null,
            silinder: null,
            startYear: null,
            endYear: null,
            period: null,
            city: null,
            transmisi: null,
          });
          setFilters({
            // brand: [],
            ...filters,
            seri: [],
            tipe: [],
            silinder: [],
            startYear: [],
            endYear: [],
            period: [
              { value: null, label: 'Pilih Periode' },
              { value: '6', label: '6 Bulan' },
              { value: '5', label: '5 Bulan' },
              { value: '4', label: '4 Bulan' },
              { value: '3', label: '3 Bulan' },
              { value: '2', label: '2 Bulan' },
              { value: '1', label: '1 Bulan' },
            ],
            city: [],
            transmisi: '',
          });
        }

        break;

      case 'seri':
        if (event.target.value) {
          getTipe(selectedValue.brand, event.target.value).then((res) => {
            setSelected({
              ...selectedValue,
              ...{
                // brand: null,
                // seri: null,
                tipe: null,
                silinder: null,
                startYear: null,
                endYear: null,
                period: null,
                city: null,
                transmisi: null,
              },
              seri: event.target.value,
              series: event.target.value,
            });
            setFilters({ ...filters, tipe: res });
          });
        } else {
          setSelected({
            ...selectedValue,
            // brand: null,
            seri: null,
            tipe: null,
            silinder: null,
            startYear: null,
            endYear: null,
            period: null,
            city: null,
            transmisi: null,
          });
          setFilters({
            ...filters,
            // brand: [],
            // seri: [],
            tipe: [],
            silinder: [],
            startYear: [],
            endYear: [],
            period: [
              { value: null, label: 'Pilih Periode' },
              { value: '6', label: '6 Bulan' },
              { value: '5', label: '5 Bulan' },
              { value: '4', label: '4 Bulan' },
              { value: '3', label: '3 Bulan' },
              { value: '2', label: '2 Bulan' },
              { value: '1', label: '1 Bulan' },
            ],
            city: [],
            transmisi: '',
          });
        }

        break;

      case 'tipe':
        if (event.target.value) {
          getSilinder(selectedValue.brand, selectedValue.seri, event.target.value).then((res) => {
            setSelected({
              ...selectedValue,
              ...{
                // brand: null,
                // seri: null,
                // tipe: null,
                silinder: null,
                startYear: null,
                endYear: null,
                period: null,
                city: null,
                transmisi: null,
              },
              tipe: event.target.value,
              type: event.target.value,
            });
            setFilters({ ...filters, silinder: res });
          });
        } else {
          setSelected({
            ...selectedValue,
            // brand: null,
            // seri: null,
            tipe: null,
            silinder: null,
            startYear: null,
            endYear: null,
            period: null,
            city: null,
            transmisi: null,
          });
          setFilters({
            ...filters,
            // brand: [],
            // seri: [],
            // tipe: [],
            silinder: [],
            startYear: [],
            endYear: [],
            period: [
              { value: null, label: 'Pilih Periode' },
              { value: '6', label: '6 Bulan' },
              { value: '5', label: '5 Bulan' },
              { value: '4', label: '4 Bulan' },
              { value: '3', label: '3 Bulan' },
              { value: '2', label: '2 Bulan' },
              { value: '1', label: '1 Bulan' },
            ],
            city: [],
            transmisi: '',
          });
        }

        break;

      case 'silinder':
        if (event.target.value) {
          getTahun(selectedValue.brand, selectedValue.seri, selectedValue.tipe, event.target.value).then((res) => {
            setSelected({
              ...selectedValue,
              ...{
                // brand: null,
                // seri: null,
                // tipe: null,
                // silinder: null,
                startYear: null,
                endYear: null,
                period: null,
                city: null,
                transmisi: null,
              },
              silinder: event.target.value,
              cylinder: event.target.value,
            });
            setFilters({ ...filters, startYear: res, endYear: res, year: res });
          });
        } else {
          setSelected({
            ...selectedValue,
            // brand: null,
            // seri: null,
            // tipe: null,
            silinder: null,
            startYear: null,
            endYear: null,
            period: null,
            city: null,
            transmisi: null,
          });
          setFilters({
            ...filters,
            // brand: [],
            // seri: [],
            // tipe: [],
            // silinder: [],
            startYear: [],
            endYear: [],
            period: [
              { value: null, label: 'Pilih Periode' },
              { value: '6', label: '6 Bulan' },
              { value: '5', label: '5 Bulan' },
              { value: '4', label: '4 Bulan' },
              { value: '3', label: '3 Bulan' },
              { value: '2', label: '2 Bulan' },
              { value: '1', label: '1 Bulan' },
            ],
            city: [],
            transmisi: '',
          });
        }

        break;

      case 'startYear':
        if (event.target.value) {
          setSelected({
            ...selectedValue,
            ...{
              // brand: null,
              // seri: null,
              // tipe: null,
              // silinder: null,
              // startYear: null,
              endYear: null,
              period: null,
              city: null,
              transmisi: null,
            },
            startYear: event.target.value,
            year: event.target.value,
          });
        } else {
          setSelected({
            ...selectedValue,
            ...{
              // brand: null,
              // seri: null,
              // tipe: null,
              // silinder: null,
              startYear: null,
              endYear: null,
              period: null,
              city: null,
              transmisi: null,
            },
          });
        }

        break;

      case 'endYear':
        if (event.target.value) {
          getKota(
            selectedValue.brand,
            selectedValue.seri,
            selectedValue.tipe,
            selectedValue.silinder,
            selectedValue.startYear,
            event.target.value
          ).then((res) => {
            setSelected({
              ...selectedValue,
              ...{
                // brand: null,
                // seri: null,
                // tipe: null,
                // silinder: null,
                // startYear: null,
                // endYear: null,
                period: null,
                city: null,
                transmisi: null,
              },
              endYear: event.target.value,
            });
            setFilters({ ...filters, city: res });
          });
        } else {
          setSelected({
            ...selectedValue,
            // brand: null,
            // seri: null,
            // tipe: null,
            // silinder: null,
            // startYear: null,
            endYear: null,
            period: null,
            city: null,
            transmisi: null,
          });
          setFilters({
            ...filters,
            // brand: [],
            // seri: [],
            // tipe: [],
            // silinder: [],
            // startYear: [],
            // endYear: [],
            period: [
              { value: null, label: 'Pilih Periode' },
              { value: '6', label: '6 Bulan' },
              { value: '5', label: '5 Bulan' },
              { value: '4', label: '4 Bulan' },
              { value: '3', label: '3 Bulan' },
              { value: '2', label: '2 Bulan' },
              { value: '1', label: '1 Bulan' },
            ],
            city: [],
            transmisi: '',
          });
        }

        break;

      case 'city':
        if (event.target.value) {
          getTransmisi(
            selectedValue.brand,
            selectedValue.seri,
            selectedValue.tipe,
            selectedValue.cylinder,
            selectedValue.startYear,
            selectedValue.endYear,
            event.target.value,
          ).then((res) => {
            setSelected({
              ...selectedValue,
              ...{
                // brand: null,
                // seri: null,
                // tipe: null,
                // silinder: null,
                // startYear: null,
                // endYear: null,
                period: null,
                // city: null,
                transmisi: null,
              },
              city: event.target.value,
            });
            setFilters({ ...filters, transmisi: res });
          });
        } else {
          setSelected({
            ...selectedValue,
            // brand: null,
            // seri: null,
            // tipe: null,
            // silinder: null,
            // startYear: null,
            // endYear: null,
            period: null,
            city: null,
            transmisi: null,
          });
          setFilters({
            ...filters,
            // brand: [],
            // seri: [],
            // tipe: [],
            // silinder: [],
            // startYear: [],
            // endYear: [],
            period: [
              { value: null, label: 'Pilih Periode' },
              { value: '6', label: '6 Bulan' },
              { value: '5', label: '5 Bulan' },
              { value: '4', label: '4 Bulan' },
              { value: '3', label: '3 Bulan' },
              { value: '2', label: '2 Bulan' },
              { value: '1', label: '1 Bulan' },
            ],
            // city: [],
            transmisi: '',
          });
        }

        break;

      // case 'model':
      // 	setSelected({ ...selectedValue, model: event.target.value });
      // 	break;

      // case 'grade':
      // 	setSelected({ ...selectedValue, grade: event.target.value });
      // 	break;

      case 'transmisi':
        if (event.target.value) {
          getTransmisi(
            selectedValue.brand,
            selectedValue.seri,
            selectedValue.tipe,
            selectedValue.cylinder,
            selectedValue.startYear,
            selectedValue.endYear,
            selectedValue.city,
          ).then((res) => {
            setSelected({
              ...selectedValue,
              ...{
                // brand: null,
                // seri: null,
                // tipe: null,
                // silinder: null,
                // startYear: null,
                // endYear: null,
                period: null,
                // city: null,
                // transmisi: null,
              },
              transmisi: event.target.value,
            });
            setFilters({ ...filters, transmisi: res });
          });
        } else {
          setSelected({
            ...selectedValue,
            // brand: null,
            // seri: null,
            // tipe: null,
            // silinder: null,
            // startYear: null,
            // endYear: null,
            period: null,
            // city: null,
            transmisi: null,
          });
          setFilters({
            ...filters,
            // brand: [],
            // seri: [],
            // tipe: [],
            // silinder: [],
            // startYear: [],
            // endYear: [],
            period: [
              { value: null, label: 'Pilih Periode' },
              { value: '6', label: '6 Bulan' },
              { value: '5', label: '5 Bulan' },
              { value: '4', label: '4 Bulan' },
              { value: '3', label: '3 Bulan' },
              { value: '2', label: '2 Bulan' },
              { value: '1', label: '1 Bulan' },
            ],
            // city: [],
            // transmisi: '',
          });
        }

        break;

      case 'period':
        setSelected({ ...selectedValue, period: event.target.value });
        break;

      // case 'tahun':
      // 	setSelected({ ...selectedValue, warna: event.target.value });
      // 	break;

      // case 'warna':
      // 	setSelected({ ...selectedValue, warna: event.target.value });
      // 	break;
    }
  };

  useEffect(() => {
    if (selectedValue.startYear) {
      const filteredEndYear = filters.startYear.map((y) => ({
        ...y,
        disabled: y.value && y.value < selectedValue.startYear,
      }));
      setFilters({ ...filters, endYear: filteredEndYear });
    }
  }, [selectedValue.startYear]);

  const onReset = () => {
    resetFilterOverview();
    setFilters({
      merk: [{ value: null, label: 'Pilih Merek' }],
      seri: [{ value: null, label: 'Pilih Seri' }],
      tipe: [{ value: null, label: 'Pilih Tipe' }],
      silinder: [{ value: null, label: 'Pilih Silinder' }],
      startYear: [{ value: null, label: 'Pilih Tahun' }],
      endYear: [{ value: null, label: 'Pilih Tahun' }],
      period: [
        { value: null, label: 'Pilih Periode' },
        { value: '6', label: '6 Bulan' },
        { value: '5', label: '5 Bulan' },
        { value: '4', label: '4 Bulan' },
        { value: '3', label: '3 Bulan' },
        { value: '2', label: '2 Bulan' },
        { value: '1', label: '1 Bulan' },
      ],
      city: [{ value: null, label: 'Pilih Kota' }],
      transmisi: [
        { value: null, label: 'Pilih Transmisi' },
        { value: 'AT', label: 'AT' },
        { value: 'MT', label: 'MT' },
      ],
    });

    getMerk().then((res) => {
      setFilters({ ...filters, brand: res });
    });

    setSelected({
      brand: null,
      seri: null,
      tipe: null,
      silinder: null,
      startYear: null,
      endYear: null,
      period: null,
      city: null,
      transmisi: null,
    });
  };

  return (
    <div className="col-lg-12 col-md-6 col-sm-12 d-lg-block d-md-block d-sm-none">
      <p className="findprice-subtitle">Filter Pencarian</p>
      <div className="form-row horizontal">
        <Filter
          selected={selectedValue.brand}
          disabled={false}
          name="brand"
          options={filters.brand}
          onChange={(event) => {
            onChange(event);
          }}
          label="Merek"
        />
        <Filter
          selected={selectedValue.seri}
          disabled={selectedValue.brand != null ? false : true}
          options={filters.seri}
          name="seri"
          onChange={(event) => {
            onChange(event);
          }}
          label="Seri"
        />
        <Filter
          selected={selectedValue.tipe}
          disabled={selectedValue.seri != null ? false : true}
          options={filters.tipe}
          name="tipe"
          onChange={(event) => {
            onChange(event);
          }}
          label="Tipe"
        />
        <Filter
          selected={selectedValue.silinder}
          disabled={selectedValue.tipe != null ? false : true}
          options={filters.silinder}
          name="silinder"
          onChange={(event) => {
            onChange(event);
          }}
          label="Silinder"
        />
      </div>
      <div className="form-row mt-1">
        <Filter
          selected={selectedValue.startYear}
          disabled={selectedValue.silinder != null ? false : true}
          options={filters.startYear}
          name="startYear"
          onChange={(event) => {
            onChange(event);
          }}
          label="Dari Tahun"
        />
        <Filter
          selected={selectedValue.endYear}
          disabled={selectedValue.startYear != null ? false : true}
          options={filters.endYear}
          name="endYear"
          onChange={(event) => {
            onChange(event);
          }}
          label="Sampai Tahun"
        />
        <Filter
          selected={selectedValue.city}
          disabled={selectedValue.endYear != null ? false : true}
          options={filters.city}
          name="city"
          onChange={(event) => {
            onChange(event);
          }}
          label="Kota"
        />
        <Filter
          selected={selectedValue.transmisi}
          disabled={selectedValue.city != null ? false : true}
          options={filters.transmisi}
          name="transmisi"
          onChange={(event) => {
            onChange(event);
          }}
          label="Transmisi"
        />
      </div>
      <div className="form-row mt-1">
        <Filter
          selected={selectedValue.period}
          disabled={selectedValue.transmisi != null ? false : true}
          options={filters.period}
          name="period"
          onChange={(event) => {
            onChange(event);
          }}
          label="Periode Data"
        />
        <div className="col-lg-9 col-md-12 d-flex justify-content-end align-items-end">
          <div className="form-row">
            <div className="col-6">
              <button className="btn-findprice-red" onClick={onReset}>
                Reset Filter
              </button>
            </div>

            <div className="col-6">
              <button
                className={`btn-findprice-green-solid ${selectedValue.brand == null ||
                  selectedValue.series == null ||
                  selectedValue.seri == null ||
                  selectedValue.tipe == null ||
                  selectedValue.type == null ||
                  selectedValue.silinder == null ||
                  selectedValue.cylinder == null ||
                  selectedValue.startYear == null ||
                  selectedValue.endYear == null ||
                  selectedValue.period == null ||
                  selectedValue.city == null ||
                  selectedValue.transmisi == null
                  ? 'disabled'
                  : ''
                  }`}
                onClick={onCariHarga}
                disabled={
                  selectedValue.brand == null ||
                    selectedValue.series == null ||
                    selectedValue.seri == null ||
                    selectedValue.tipe == null ||
                    selectedValue.type == null ||
                    selectedValue.silinder == null ||
                    selectedValue.cylinder == null ||
                    selectedValue.startYear == null ||
                    selectedValue.endYear == null ||
                    selectedValue.period == null ||
                    selectedValue.city == null ||
                    selectedValue.transmisi == null
                    ? true
                    : false
                }
              >
                Cari Harga
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
